export const SHIFT_DETAILS_FOOTER_LOG_EVENT_SOURCE_UI = "shift-details-footer";

export const ALREADY_STARTED_WORKING_THRESHOLD_MINUTES = 3;

export const SKIP_WORKPLACE_SIGNATURE_QUERY_PARAM_KEY = "skipWorkplaceSignature";

export const UNVERIFIED_TIMESHEET_RETURN_PATH_STATE_KEY = "returnPath";
